import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { assets, navLinks } from "@/lib/site-data";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "fixed inset-x-0 top-0 z-50 transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]",
        scrolled
          ? "border-b border-border bg-background/85 backdrop-blur-md"
          : "border-b border-transparent bg-transparent",
      )}
    >
      <div className="container-artbaz flex h-24 items-center justify-between md:h-28">
        <a
          href="/"
          className="relative flex h-full items-center"
          aria-label="ARTBAZ domov"
        >
          {/* Logo enlarged for stronger brand presence */}
          <img
            src={assets.logo}
            alt="ARTBAZ"
            className="h-16 w-auto sm:h-20 md:h-24"
          />
        </a>

        <nav className="hidden items-center gap-10 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="relative text-base font-semibold text-foreground/80 transition-colors hover:text-primary-dark after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button asChild variant="hero" size="lg">
            <a href="/kontakt">Kontakt</a>
          </Button>
        </div>


        <button
          type="button"
          className="flex h-11 w-11 items-center justify-center rounded-full text-foreground lg:hidden"
          aria-label={open ? "Zavrieť menu" : "Otvoriť menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="size-6" /> : <Menu className="size-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={cn(
          "overflow-hidden border-border bg-background/95 backdrop-blur-md transition-[max-height,opacity] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] lg:hidden",
          open ? "max-h-96 border-b opacity-100" : "max-h-0 opacity-0",
        )}
      >
        <nav className="container-artbaz flex flex-col gap-1 py-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-3 text-base font-semibold text-foreground/85 transition-colors hover:bg-secondary hover:text-primary-dark"
            >
              {link.label}
            </a>
          ))}
          <Button asChild variant="hero" className="mt-2 w-full">
            <a href="/kontakt" onClick={() => setOpen(false)}>
              Kontakt
            </a>
          </Button>
        </nav>
      </div>
    </header>
  );
}
